import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";

function requireEnv(name: string): string {
  const value = process.env[name];
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
}

const firebaseConfig = {
  apiKey: requireEnv("REACT_APP_FIREBASE_API_KEY"),
  authDomain: requireEnv("REACT_APP_FIREBASE_AUTH_DOMAIN"),
  projectId: requireEnv("REACT_APP_FIREBASE_PROJECT_ID"),
  storageBucket: requireEnv("REACT_APP_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: requireEnv("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
  appId: requireEnv("REACT_APP_FIREBASE_APP_ID"),
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Connect to Firebase Auth emulator if configured
if (process.env.REACT_APP_USE_FIREBASE_EMULATOR === "true") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
}

export { auth }; 

